/* DriveMode — JS du thème. Vanilla, sans dépendance. */
(() => {
  'use strict';

  const DM = window.DM || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Argent ---------- */
  function formatMoney(cents, format = DM.moneyFormat || '{{amount_with_comma_separator}} €') {
    const value = Number(cents) / 100;
    const fmt = (n, decimals, thousands, dec) => {
      const fixed = n.toFixed(decimals);
      const [int, frac] = fixed.split('.');
      const withSep = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? withSep + dec + frac : withSep;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(value, 2, ',', '.');
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(value, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        default: return fmt(value, 2, ' ', ',');
      }
    });
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(message) {
    const el = $('#Toast');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 2600);
  }

  /* ---------- Tiroirs (menu, panier) ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const focusable = $('[data-drawer-close]', drawer);
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }

  /* Un seul écouteur de clic délégué pour tout le thème : évite les conflits de propagation. */
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    const closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('.drawer'));
      return;
    }
    const searchOpen = event.target.closest('[data-search-open]');
    if (searchOpen) {
      event.preventDefault();
      openSearch();
      return;
    }
    if (event.target.closest('[data-search-close]')) {
      event.preventDefault();
      closeSearch();
      return;
    }
    const qtyBtn = event.target.closest('[data-qty]');
    if (qtyBtn) {
      event.preventDefault();
      const wrap = qtyBtn.closest('.qty');
      const input = wrap && $('input', wrap);
      if (!input) return;
      const step = qtyBtn.getAttribute('data-qty') === 'plus' ? 1 : -1;
      const min = Number(input.min || 0);
      input.value = Math.max(min, (Number(input.value) || 0) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      changeLine(Number(remove.getAttribute('data-cart-remove')), 0);
    }
  });

  /* Garde le focus clavier à l'intérieur du tiroir ou de la fenêtre ouverte. */
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
  function activeLayer() {
    const modal = document.querySelector('.search-modal:not([hidden]), dialog[open]');
    if (modal) return modal;
    const drawers = $$('.drawer.is-open');
    return drawers.length ? $('.drawer__panel', drawers[drawers.length - 1]) : null;
  }
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      $$('.drawer.is-open').forEach(closeDrawer);
      closeSearch();
      return;
    }
    if (event.key !== 'Tab') return;
    const layer = activeLayer();
    if (!layer) return;
    const items = $$(FOCUSABLE, layer).filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (!layer.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ---------- Panier (AJAX + Section Rendering API) ---------- */
  const CART_SECTION = 'cart-drawer';

  function renderCartSection(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer-inner]');
    const current = $('[data-cart-drawer-inner]');
    if (fresh && current) current.replaceWith(fresh);
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  async function refreshCart() {
    const res = await fetch(`${DM.routes.root.replace(/\/$/, '')}/?sections=${CART_SECTION}`);
    const data = await res.json();
    renderCartSection(data[CART_SECTION]);
    const cart = await (await fetch(`${DM.routes.cart}.js`)).json();
    updateCount(cart.item_count);
  }

  async function changeLine(line, quantity) {
    const drawer = $('[data-cart-drawer-inner]');
    if (drawer) drawer.classList.add('is-loading');
    try {
      const res = await fetch(`${DM.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: CART_SECTION })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || DM.strings.error);
      renderCartSection(data.sections && data.sections[CART_SECTION]);
      updateCount(data.item_count);
      if (document.body.classList.contains('template-cart')) window.location.reload();
    } catch (err) {
      toast(err.message || DM.strings.error);
      if (drawer) drawer.classList.remove('is-loading');
    }
  }

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-line]');
    if (input) changeLine(Number(input.getAttribute('data-cart-line')), Math.max(0, Number(input.value) || 0));
  });

  document.addEventListener('submit', async (event) => {
    const bundle = event.target.closest('form[data-bundle-form]');
    if (bundle) {
      event.preventDefault();
      const button = $('[type="submit"]', bundle);
      if (button) button.classList.add('is-loading');
      const items = $$('[name^="bundle-"]', bundle).map((el) => ({ id: Number(el.value), quantity: 1 }));
      try {
        const res = await fetch(`${DM.routes.cartAdd}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: CART_SECTION })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || DM.strings.error);
        renderCartSection(data.sections && data.sections[CART_SECTION]);
        const cart = await (await fetch(`${DM.routes.cart}.js`)).json();
        updateCount(cart.item_count);
        openDrawer('CartDrawer');
      } catch (err) {
        toast(err.message || DM.strings.error);
      } finally {
        if (button) button.classList.remove('is-loading');
      }
      return;
    }
    const form = event.target.closest('form[data-product-form]');
    if (!form) return;
    event.preventDefault();
    // Un seul envoi à la fois : évite le double ajout (double clic, barre collante).
    if (form.__dmBusy) return;
    form.__dmBusy = true;
    const button = $('[type="submit"]', form);
    const hasFile = $$('input[type="file"]', form).some((input) => input.files && input.files.length);
    const label = button ? button.innerHTML : '';
    const wasDisabled = button ? button.disabled : false;
    if (button) {
      button.classList.add('is-loading');
      button.disabled = true;
      if (hasFile) button.textContent = button.getAttribute('data-uploading-label') || 'Envoi de ta photo…';
    }
    const formData = new FormData(form);
    formData.append('sections', CART_SECTION);
    formData.append('sections_url', window.location.pathname);
    try {
      const res = await fetch(`${DM.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || DM.strings.error);
      renderCartSection(data.sections && data.sections[CART_SECTION]);
      const cart = await (await fetch(`${DM.routes.cart}.js`)).json();
      updateCount(cart.item_count);
      openDrawer('CartDrawer');
    } catch (err) {
      toast(err.message || DM.strings.error);
    } finally {
      form.__dmBusy = false;
      if (button) {
        button.classList.remove('is-loading');
        button.disabled = wasDisabled;
        button.innerHTML = label;
      }
    }
  });

  /* ---------- Sélecteur de variante ---------- */
  function initVariantPicker(root) {
    const dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const form = $('form[data-product-form]', root);
    const idInput = form && $('input[name="id"]', form);
    const submit = form && $('[type="submit"]', form);
    const priceEl = $('[data-price]', root);
    const compareEl = $('[data-compare-price]', root);
    const stickyPrice = $('[data-sticky-price]');
    const stockEl = $('[data-stock]', root);
    const threshold = Number(root.getAttribute('data-low-stock') || 0);

    function selectedOptions() {
      return $$('[data-option-index]', root).map((fieldset) => {
        const checked = $('input:checked', fieldset);
        return checked ? checked.value : null;
      });
    }

    function markAvailability(current) {
      $$('[data-option-index]', root).forEach((fieldset) => {
        const index = Number(fieldset.getAttribute('data-option-index'));
        $$('input', fieldset).forEach((input) => {
          const candidate = current.slice();
          candidate[index] = input.value;
          const match = product.variants.find((v) => v.options.every((o, i) => o === candidate[i]));
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function update() {
      const current = selectedOptions();
      const variant = product.variants.find((v) => v.options.every((o, i) => o === current[i]));
      $$('[data-option-index]', root).forEach((fieldset) => {
        const label = $('[data-option-value]', fieldset);
        const checked = $('input:checked', fieldset);
        if (label && checked) label.textContent = checked.value;
      });
      markAvailability(current);
      if (!variant) {
        if (submit) { submit.disabled = true; submit.textContent = DM.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (compareEl) {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price);
      }
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? DM.strings.addToCart : DM.strings.soldOut;
      }
      $$('[data-sticky-submit]').forEach((b) => {
        b.disabled = !variant.available;
        b.textContent = variant.available ? DM.strings.addToCart : DM.strings.soldOut;
      });
      const restock = $('[data-restock]', root);
      if (restock && !root.hasAttribute('data-coming-soon')) {
        restock.hidden = variant.available;
        const body = $('[data-restock-body]', restock);
        if (body) body.value = body.getAttribute('data-prefix') + variant.options.join(' / ');
      }
      if (stockEl) {
        const qty = variant.inventory_quantity;
        const tracked = variant.inventory_management === 'shopify';
        const show = tracked && variant.available && threshold > 0 && qty > 0 && qty <= threshold;
        stockEl.hidden = !show;
        if (show) stockEl.textContent = stockEl.getAttribute('data-template').replace('{count}', qty);
      }
      if (variant.featured_media) {
        const media = $(`[data-media-id="${variant.featured_media.id}"]`, root);
        if (media) {
          const gallery = media.parentElement;
          if (window.matchMedia('(max-width: 989px)').matches) {
            gallery.scrollTo({ left: media.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
          }
        }
      }
      document.dispatchEvent(new CustomEvent('dm:variant-change', { detail: { productId: product.id, variant } }));
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.addEventListener('change', (event) => {
      if (event.target.closest('[data-option-index]')) update();
    });
    update();
  }

  /* ---------- Barre d'achat collante (mobile) ---------- */
  function initStickyAtc() {
    const bar = $('[data-sticky-atc]');
    const target = $('[data-product-form]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    io.observe(target);
    bar.addEventListener('click', (event) => {
      if (event.target.closest('[data-sticky-submit]')) {
        event.preventDefault();
        target.requestSubmit();
      }
    });
  }

  /* ---------- Compte à rebours ---------- */
  function initCountdowns() {
    $$('[data-countdown]').forEach((el) => {
      const end = new Date(el.getAttribute('data-countdown')).getTime();
      if (Number.isNaN(end)) { el.hidden = true; return; }
      const cells = {
        d: $('[data-unit="d"]', el), h: $('[data-unit="h"]', el),
        m: $('[data-unit="m"]', el), s: $('[data-unit="s"]', el)
      };
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let diff = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (diff === 0) {
          el.setAttribute('data-ended', 'true');
          if (el.hasAttribute('data-reload-on-end') && !el.dataset.reloaded) {
            el.dataset.reloaded = '1';
            setTimeout(() => window.location.reload(), 1500);
          }
          const live = el.parentElement && $('[data-countdown-live]', el.parentElement);
          if (live) { el.hidden = true; live.hidden = false; }
        }
        const d = Math.floor(diff / 86400); diff -= d * 86400;
        const h = Math.floor(diff / 3600); diff -= h * 3600;
        const m = Math.floor(diff / 60); const s = diff - m * 60;
        if (cells.d) cells.d.textContent = pad(d);
        if (cells.h) cells.h.textContent = pad(h);
        if (cells.m) cells.m.textContent = pad(m);
        if (cells.s) cells.s.textContent = pad(s);
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Recherche prédictive ---------- */
  const searchModal = () => $('#SearchModal');
  function openSearch() {
    const modal = searchModal();
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    const input = $('input[type="search"]', modal);
    if (input) setTimeout(() => input.focus(), 30);
  }
  function closeSearch() {
    const modal = searchModal();
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }
  function initPredictiveSearch() {
    const modal = searchModal();
    if (!modal) return;
    const input = $('input[type="search"]', modal);
    const results = $('[data-search-results]', modal);
    let timer;
    let controller;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        if (controller) controller.abort();
        controller = new AbortController();
        try {
          const url = `${DM.routes.search}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page&resources[limit]=6&resources[options][fields]=title,product_type,tag,variants.title&section_id=predictive-search`;
          const res = await fetch(url, { signal: controller.signal });
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-predictive-results]');
          results.innerHTML = fresh ? fresh.innerHTML : '';
        } catch (e) { /* requête annulée */ }
      }, 220);
    });
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeSearch();
    });
  }

  /* ---------- Zoom des photos produit ---------- */
  function initZoom() {
    const dialog = $('#ZoomDialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const img = $('[data-zoom-img]', dialog);
    let items = [];
    let index = 0;
    const show = (i) => {
      index = (i + items.length) % items.length;
      img.src = items[index].getAttribute('data-zoom');
      const inner = $('img', items[index]);
      img.alt = inner ? inner.alt : '';
    };
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-zoom]');
      if (trigger) {
        items = $$('[data-zoom]');
        show(items.indexOf(trigger));
        lastFocus = trigger;
        dialog.showModal();
        return;
      }
      if (event.target.closest('[data-zoom-close]') || event.target === dialog || event.target === img) {
        dialog.close();
        return;
      }
      const step = event.target.closest('[data-zoom-step]');
      if (step) show(index + Number(step.getAttribute('data-zoom-step')));
    });
    document.addEventListener('keydown', (event) => {
      const trigger = event.target.closest && event.target.closest('[data-zoom]');
      if (trigger && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        trigger.click();
      }
      if (dialog.open && (event.key === 'ArrowRight' || event.key === 'ArrowLeft')) {
        show(index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    dialog.addEventListener('close', () => { if (lastFocus) lastFocus.focus(); });
  }

  /* ---------- Visualiseur 3D (chargé à la demande) ---------- */
  let viewerModule = null;
  function hasWebGL() {
    try {
      const c = document.createElement('canvas');
      return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl')));
    } catch (e) { return false; }
  }
  function mountViewer(el) {
    if (el.hasAttribute('data-v3d-mounted')) return;
    el.setAttribute('data-v3d-mounted', '');
    if (!hasWebGL() || !DM.viewer3d) { el.classList.add('is-error'); return; }
    el.classList.add('is-loading');
    viewerModule = viewerModule || import(DM.viewer3d);
    viewerModule.then((m) => { m.mount(el); startView(el); }).catch((err) => {
      console.error('[DriveMode 3D]', err);
      el.classList.remove('is-loading');
      el.classList.add('is-error');
    });
  }
  // Le design est au dos : la vue démarre de dos (data-start-view="back")
  function startView(el) {
    if (el.dataset.startView !== 'back') return;
    let tries = 0;
    const t = setInterval(() => {
      const v = el.__dmViewer;
      tries += 1;
      if (v && v.root && v.camera && v.controls) {
        clearInterval(t);
        const c = v.controls.target;
        const p = v.camera.position;
        p.set(c.x - (p.x - c.x), p.y, c.z - (p.z - c.z));
        v.camera.lookAt(c);
        if (v.controls.update) v.controls.update();
        v.needsRender = true;
      } else if (tries > 100) clearInterval(t);
    }, 100);
  }
  document.addEventListener('click', (event) => {
    const btn = event.target.closest && event.target.closest('[data-v3d-external]');
    if (!btn) return;
    const el = document.getElementById(btn.getAttribute('data-v3d-external'));
    if (!el) return;
    const run = () => el.__dmViewer && el.__dmViewer.root && el.__dmViewer.goTo(btn.getAttribute('data-v3d-cmd') || 'front');
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    mountViewer(el);
    if (el.__dmViewer && el.__dmViewer.root) run(); else setTimeout(run, 1200);
  });
  function initLogos() {
    const els = $$('[data-logo3d]');
    if (!els.length || !hasWebGL() || !DM.viewer3d) return;
    const go = () => {
      viewerModule = viewerModule || import(DM.viewer3d);
      viewerModule.then((m) => els.forEach((el) => m.mountLogo && m.mountLogo(el))).catch((e) => console.warn('[DriveMode logo 3D]', e));
    };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 1200 }); else setTimeout(go, 300);
  }
  function initViewers(scope) {
    const els = $$('[data-viewer3d]', scope || document).filter((el) => !el.hasAttribute('data-v3d-mounted'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(mountViewer); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { io.unobserve(entry.target); mountViewer(entry.target); }
      });
    }, { rootMargin: '300px 0px' });
    els.forEach((el) => io.observe(el));
  }

  /* ---------- v3 : effets et sections ---------- */
  const reduced = () => document.body.classList.contains('reduce-motion') || window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(scope) {
    const els = $$('[data-reveal]', scope || document).filter((el) => !el.classList.contains('is-revealed'));
    if (!document.body.classList.contains('has-reveal') || reduced() || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-revealed'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px 15% 0px', threshold: 0 });
    els.forEach((el) => io.observe(el));
    // Filet de sécurité : rien ne doit rester masqué (défilement rapide, ancres, captures)
    const sweep = () => {
      const limit = window.innerHeight * 1.15;
      els.forEach((el) => { if (!el.classList.contains('is-revealed') && el.getBoundingClientRect().top < limit) { el.classList.add('is-revealed'); io.unobserve(el); } });
    };
    window.addEventListener('scroll', sweep, { passive: true });
    window.addEventListener('load', sweep);
    setTimeout(sweep, 1200);
  }

  function initSliders(scope) {
    $$('[data-slider]', scope || document).forEach((root) => {
      if (root.__slider) return; root.__slider = true;
      const track = $('[data-slider-track]', root);
      if (!track) return;
      const step = () => { const c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : track.clientWidth; };
      const go = (dir) => {
        const max = track.scrollWidth - track.clientWidth - 4;
        if (dir > 0 && track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'smooth' });
        else if (dir < 0 && track.scrollLeft <= 4) track.scrollTo({ left: max, behavior: 'smooth' });
        else track.scrollBy({ left: dir * step(), behavior: 'smooth' });
      };
      const prev = $('[data-slider-prev]', root); const next = $('[data-slider-next]', root);
      if (prev) prev.addEventListener('click', () => go(-1));
      if (next) next.addEventListener('click', () => go(1));
      const auto = Number(root.getAttribute('data-autoplay') || 0);
      if (auto && !reduced() && root.classList.contains('tm--slider')) {
        let timer = setInterval(() => go(1), auto * 1000);
        root.addEventListener('pointerenter', () => clearInterval(timer));
        root.addEventListener('pointerleave', () => { clearInterval(timer); timer = setInterval(() => go(1), auto * 1000); });
      }
    });
  }

  function initCounters(scope) {
    const els = $$('[data-count-to]', scope || document);
    if (!els.length) return;
    const run = (el) => {
      const to = Number(el.getAttribute('data-count-to')) || 0;
      const dec = Number(el.getAttribute('data-decimals') || 0);
      const fmt = (n) => n.toLocaleString('fr-FR', { minimumFractionDigits: dec, maximumFractionDigits: dec });
      if (reduced()) { el.textContent = fmt(to); return; }
      const t0 = performance.now(); const dur = 1600;
      const tick = (now) => {
        const k = Math.min(1, (now - t0) / dur); const e = 1 - Math.pow(1 - k, 3);
        el.textContent = fmt(to * e);
        if (k < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } }), { threshold: 0.4 });
    els.forEach((el) => io.observe(el));
  }

  function initCompare(scope) {
    $$('[data-compare]', scope || document).forEach((root) => {
      const r = $('[data-compare-range]', root);
      if (!r || r.__bound) return; r.__bound = true;
      const set = () => root.style.setProperty('--pos', r.value + '%');
      r.addEventListener('input', set); set();
    });
  }

  function initVideoEmbeds() {
    document.addEventListener('click', (event) => {
      const btn = event.target.closest && event.target.closest('[data-video-embed]');
      if (!btn) return;
      const id = btn.getAttribute('data-id'); const provider = btn.getAttribute('data-provider');
      const src = provider === 'vimeo'
        ? `https://player.vimeo.com/video/${id}?autoplay=1`
        : `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1`;
      const iframe = document.createElement('iframe');
      iframe.src = src; iframe.allow = 'autoplay; fullscreen; picture-in-picture'; iframe.allowFullscreen = true; iframe.title = 'Vidéo';
      btn.replaceWith(iframe);
    });
  }

  function initParallax() {
    const items = $$('[data-parallax]').map((m) => m.closest('.ib')).filter(Boolean).map((ib) => $('.ib__media', ib)).filter(Boolean);
    if (!items.length || reduced()) return;
    let ticking = false;
    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      items.forEach((m) => {
        const r = m.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const p = (r.top + r.height / 2 - vh / 2) / vh;
        m.style.transform = `translate3d(0, ${(-p * 10).toFixed(2)}%, 0)`;
      });
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  function initHeaderFx() {
    const wrap = $('.header-wrapper');
    if (!wrap) return;
    const body = document.body;
    const autohide = body.classList.contains('header-autohide');
    const transparent = body.classList.contains('header-transparent');
    if (!autohide && !transparent) return;
    let last = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      if (transparent) wrap.classList.toggle('is-scrolled', y > 40);
      if (autohide) {
        const anyOpen = document.querySelector('.drawer[aria-hidden="false"]');
        wrap.classList.toggle('is-hidden', !anyOpen && y > 160 && y > last);
      }
      last = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initToTop() {
    const b = $('[data-to-top]');
    if (!b) return;
    const on = () => b.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.9);
    window.addEventListener('scroll', on, { passive: true }); on();
    b.addEventListener('click', () => window.scrollTo({ top: 0, behavior: reduced() ? 'auto' : 'smooth' }));
  }

  function initCursorGlow() {
    const g = $('[data-cursor-glow]');
    if (!g || reduced()) return;
    let x = -999; let y = -999; let gx = x; let gy = y; let raf = null;
    const loop = () => {
      gx += (x - gx) * 0.18; gy += (y - gy) * 0.18;
      g.style.transform = `translate3d(${gx}px, ${gy}px, 0)`;
      raf = Math.abs(x - gx) + Math.abs(y - gy) > 0.5 ? requestAnimationFrame(loop) : null;
    };
    window.addEventListener('pointermove', (e) => { if (e.pointerType !== 'mouse') return; x = e.clientX; y = e.clientY; if (!raf) raf = requestAnimationFrame(loop); }, { passive: true });
  }

  function initCardTilt() {
    if (reduced() || !document.body.classList.contains('card-hover-tilt')) return;
    document.addEventListener('pointermove', (e) => {
      const card = e.target.closest && e.target.closest('[data-tilt]');
      $$('[data-tilt].is-tilting').forEach((c) => { if (c !== card) { c.classList.remove('is-tilting'); c.style.transform = ''; } });
      if (!card || e.pointerType !== 'mouse') return;
      const r = card.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width - 0.5; const py = (e.clientY - r.top) / r.height - 0.5;
      card.classList.add('is-tilting');
      card.style.transform = `perspective(900px) rotateY(${(px * 10).toFixed(2)}deg) rotateX(${(-py * 10).toFixed(2)}deg)`;
    }, { passive: true });
  }

  function initPageFade() {
    if (!document.body.classList.contains('page-fade') || document.body.classList.contains('has-loader-leave') || reduced()) return;
    document.addEventListener('click', (e) => {
      const a = e.target.closest && e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank' || a.hasAttribute('download')) return;
      const url = new URL(a.href, location.href);
      if (url.origin !== location.origin || url.hash && url.pathname === location.pathname) return;
      if (a.closest('[data-drawer-open], .drawer') && a.getAttribute('href').startsWith('#')) return;
      e.preventDefault();
      document.body.classList.add('is-leaving');
      setTimeout(() => { location.href = url.href; }, 220);
    });
    window.addEventListener('pageshow', () => document.body.classList.remove('is-leaving'));
  }

  function initPopup() {
    const d = $('[data-nl-popup]');
    if (!d || typeof d.showModal !== 'function') return;
    const KEY = 'dm-nl-popup';
    const days = Number(d.getAttribute('data-days') || 7);
    const success = $('[data-nl-success]', d);
    const close = () => { d.close(); try { localStorage.setItem(KEY, String(Date.now())); } catch (e) { /* ignore */ } };
    $$('[data-nl-close]', d).forEach((b) => b.addEventListener('click', close));
    d.addEventListener('click', (e) => { if (e.target === d) close(); });
    if (success) { d.showModal(); try { localStorage.setItem(KEY, String(Date.now() + 3650 * 864e5)); } catch (e) { /* ignore */ } return; }
    let lastSeen = 0;
    try { lastSeen = Number(localStorage.getItem(KEY) || 0); } catch (e) { /* ignore */ }
    if (Date.now() - lastSeen < days * 864e5) return;
    if (window.Shopify && window.Shopify.designMode) return;
    setTimeout(() => { if (!document.querySelector('.drawer[aria-hidden="false"]')) d.showModal(); }, Number(d.getAttribute('data-delay') || 8) * 1000);
  }

  function initHeroGrid() {
    const grid = $('.hero .hero__grid');
    const hero = grid && grid.closest('.hero');
    if (!hero || !document.body.classList.contains('has-grid') || !('IntersectionObserver' in window)) return;
    new IntersectionObserver((entries) => {
      document.body.classList.toggle('hero-in-view', entries[0].isIntersecting);
    }, { threshold: 0.15 }).observe(hero);
  }

  function initV3(scope) {
    initReveal(scope);
    initSliders(scope);
    initCounters(scope);
    initCompare(scope);
  }

  /* ---------- Démarrage ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    $$('[data-product-root]').forEach(initVariantPicker);
    initStickyAtc();
    initCountdowns();
    initPredictiveSearch();
    initZoom();
    initViewers();
    initLogos();
    initV3();
    initVideoEmbeds();
    initParallax();
    initHeaderFx();
    initToTop();
    initCursorGlow();
    initCardTilt();
    initPageFade();
    initPopup();
    initHeroGrid();
    document.addEventListener('shopify:section:load', (event) => {
      $$('[data-product-root]').forEach(initVariantPicker);
      initCountdowns();
      initViewers(event.target);
      initLogos();
      initV3(event.target);
    });
  });

  window.DM.refreshCart = refreshCart;
  window.DM.formatMoney = formatMoney;
})();
